import {
  createRouter, createWebHashHistory, RouteRecordRaw,
} from 'vue-router';
import ServiceStatus from '../views/ServiceStatus.vue';
import HomeView from '../views/HomeView.vue';
import ServiceStatusItemPage from '../views/ServiceStatusItemPage.vue';
import TimetableSearch from '../views/TimetableSearch.vue';
import TimetableResult from '../views/TimetableResult.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/service-status',
    name: 'servicestatus',
    component: ServiceStatus,
  },
  {
    path: '/service-status/:routeCode',
    name: 'serviceStatusItem',
    component: ServiceStatusItemPage,
  },
  {
    path: '/service-status/map',
    name: 'serviceStatusMap', // This value is used in code please check where if you're going to change this.
    component: ServiceStatus,
  },
  {
    path: '/timetable-search',
    name: 'timetableSearch',
    component: TimetableSearch,
  },
  {
    path: '/timetable-search/:from/:to/:departureDate',
    name: 'timetableResult',
    component: TimetableResult,
    props: (route) => ({
      from: route.params.from?.toString(),
      to: route.params.to?.toString(),
      departureDate: route.params.departureDate?.toString(),
    }),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: (to): ScrollToOptions | undefined => {
    if (to.name !== 'serviceStatusItem') {
      return undefined;
    }

    const serviceStatusItemPage = document.getElementById('service-status-item-page');
    if (!serviceStatusItemPage) {
      return undefined;
    }

    const screenPosition = serviceStatusItemPage.getBoundingClientRect();
    return { left: screenPosition.left, top: screenPosition.top };
  },
});

export default router;
